import { LegalPage } from "./Legal";

export default function Privacy() {
  return <LegalPage base="privacy" path="/confidentialite" testid="privacy-page" />;
}
